import { createContext, useState } from 'react';
import PropTypes from 'prop-types';

let timer;

const calculateDisplayTime = (message) => {
  const minFullyVisibleTime = 3000;
  const maxFullyVisibleTime = 7000;
  const timePerCharacter = 50;

  const animateInDuration = 100;
  const animateOutDuration = 0;

  let displayTime = timePerCharacter * message.length;
  if (displayTime < minFullyVisibleTime) {
    displayTime = minFullyVisibleTime;
  }
  if (displayTime > maxFullyVisibleTime) {
    displayTime = maxFullyVisibleTime;
  }

  return animateInDuration + displayTime + animateOutDuration;
}

const SnackbarContext = createContext({
  message: '',
  action: null,
  type: 'neutral',
  isShown: false,
  show: (message, action, type = 'neutral') => {},
  onClose: () => {}
});

export const SnackbarProvider = ({ children }) => {
  const [ message, setMessage ] = useState('');
  const [ action, setAction ] = useState(null);
  const [ type, setType ] = useState('neutral');
  const [ isShown, setIsShown ] = useState(false);

  const showHandler = (message, action, type = 'neutral') => {
    setMessage(message);
    setAction(action);
    setType(type);
    setIsShown(true);

    timer = setTimeout(() => {
      closeHandler();
    }, calculateDisplayTime(message));
  };

  const closeHandler = () => {
    clearTimeout(timer);
    setIsShown(false);
  };

  return (
    <SnackbarContext.Provider
      value={{
        message,
        action,
        type,
        isShown,
        show: showHandler,
        onClose: closeHandler
      }}
    >
      { children }
    </SnackbarContext.Provider>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default SnackbarContext;
